import axios from 'axios';

// The companies currently holding this bundle — the blast radius of an in-place Save.
// Read-only and gated BUNDLE_VIEW, same as get.api.js.
export default function getCompanies({ id }) {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/bundle/${id}/companies`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
